import { DiscordOAuthCallback } from "./pages/DiscordOAuthCallback";
import { FacebookOAuthCallback } from "./pages/FacebookOAuthCallback";
import { GoogleOAuthCallback } from "./pages/GoogleOAuthCallback";
import { InstagramOAuthCallback } from "./pages/InstagramOAuthCallback";
import { KickOAuthCallback } from "./pages/KickOAuthCallback";
import { TikTokOAuthCallback } from "./pages/TikTokOAuthCallback";
import { TwitchOAuthCallback } from "./pages/TwitchOAuthCallback";
import { VimeoOAuthCallback } from "./pages/VimeoOAuthCallback";

const oauthRoutes = [
  {
    path: "/google-oauth-callback",
    element: <GoogleOAuthCallback />,
  },
  {
    path: "/discord-oauth-callback",
    element: <DiscordOAuthCallback />,
  },
  {
    path: "/instagram-oauth-callback",
    element: <InstagramOAuthCallback />,
  },
  {
    path: "/tiktok-oauth-callback",
    element: <TikTokOAuthCallback />,
  },
  {
    path: "/twitch-oauth-callback",
    element: <TwitchOAuthCallback />,
  },
  {
    path: "/vimeo-oauth-callback",
    element: <VimeoOAuthCallback />,
  },
  {
    path: "/facebook-oauth-callback",
    element: <FacebookOAuthCallback />,
  },
  {
    path: "/kick-oauth-callback",
    element: <KickOAuthCallback />,
  },
];

export default oauthRoutes;
